<div>

  <div class="quote-options-container" [ngClass]="{'quote-option-approved' : getApprovedQuoteOption()}"
       *ngIf="partner.AllowMultipleQuoteOptions && !invoiceOptionsBusy">
    <div class="message">
      <span *ngIf="!getApprovedQuoteOption()">
        {{
        'bikeshop.modal.update_job_card.quote_options_summary' | translate :
          {quoteOptions: invoiceOptions.length}
        }}
      </span>
      <span *ngIf="getApprovedQuoteOption()">
        {{
        'bikeshop.modal.update_job_card.quote_option_approved' | translate :
          {optionName: getApprovedQuoteOption().optionName}
        }}
      </span>
    </div>
    <div class="button" (click)="showInvoiceOptions = !showInvoiceOptions">
      {{
      (!showInvoiceOptions ?
        'bikeshop.modal.update_job_card.manage_quote_options' : 'bikeshop.modal.update_job_card.close_quote_options') |
        translate
      }}
    </div>
  </div>

  <div *ngIf="showInvoiceOptions" style="margin-top: -20px">
    <app-quote-options [partnerID]="partnerID" [jobcard]="jobcard" [messageService]="messageService"
                       (update)="updateQuoteOptions($event)"></app-quote-options>
  </div>

  <div *ngIf="!showInvoiceOptions">
    <div class="top-bar">

      <div class="row margin-top-8">
        <div class="col-5 flex" [style.visibility]="hasCouponsSetup ? 'visible' : 'hidden'">
          <div class="row" style="margin-top:auto; margin-bottom:auto; width:inherit">
            <div class="col-md-4 label">
              {{
              "bikeshop.modal.update_job_card.job_card.discount_code" | translate
              }}:
            </div>
            <div class="col-md-6 value">
              <p-inplace #couponCode>
                <span pInplaceDisplay>
                  {{ discountCode }}
                </span>
                <span pInplaceContent>
                  <div class="p-inputgroup">
                    <input pInputText type="text" [(ngModel)]="discountCode"
                           (ngModelChange)="discountCode = $event.toUpperCase()"
                           (keyup.enter)="updateCouponCode(couponCode)"/>
                    <span class="p-inputgroup-addon" (click)="updateCouponCode(couponCode)">
                      <i class="fa fa-check"></i>
                    </span>
                  </div>
                </span>
              </p-inplace>
            </div>
          </div>
        </div>
        <div class="col-3" *ngIf="canDoExternalSearch || priceGroups.length == 0">
          <div *ngIf="canDoExternalSearch">
            <div class="p-toolbar-group-right" style="margin-top:5px;">
              <p-inputSwitch [(ngModel)]="searchExternalFlag"
                             (onChange)="switchViewExternal($event)"></p-inputSwitch>
            </div>
            <div class="p-toolbar-group-right" style="margin-top:5px;">
              <p class="filter-label label">Search external</p>
            </div>
          </div>
        </div>
        <div class="col-3" *ngIf="priceGroups.length > 0">
          <p-dropdown [options]="priceGroups" [(ngModel)]="priceGroup"
                      (onChange)="updateLineItemPricesByGroup()" placeholder="Apply alternate pricing">
          </p-dropdown>
        </div>
        <div class="col-4 flex">
          <div class="product-search" joyrideStep="quoteStepOne"
               text="{{ 'bikeshop.tour.quote.step_one' | translate }}"
               (done)="tourDone()">
            <p-autoComplete #productSearchComponent [(ngModel)]="productSearch" field="SKU"
                            [suggestions]="searchResult"
                            [delay]="1000" placeholder="{{
        'bikeshop.modal.update_job_card.quote.search_sku_or_other' | translate
      }}" (completeMethod)="searchProducts($event)" (onSelect)="addLineItemAuto($event)" [disabled]="editing"
                            (keyup.enter)="getSearchResultQuantities($event, false)"
                            (keyup)="lockQuantitySearch($event)">
              <ng-template let-product pTemplate="item">
                <div class="search-row">
                  <!-- <img *ngIf="product.ExternalProductID==''"
              src="https://www.bicycleretailer.com/sites/default/files/styles/colorbox_popup/public/images/article/qualitybicycleproducts_logo_vert_rgb.jpg?itok=A20lWGap"
              style="width:25px;display:inline-block;margin-right:5px;" /> -->
                  <div class="search-row-supplier-name" *ngIf="product.ExternalProductID==''">
                    {{getSupplierInfo(product).name}}
                  </div>
                  <div class="search-row-sku">{{ product.SKU }}</div>
                  <div class="search-row-name">{{ product.Name }}</div>
                  <div class="search-row-price">
                    {{
                    product.UnitPrice ? (partner.CurrencySymbol +
                      (partner.VATInclusive ? (product.UnitPrice_IncludingTax | number: ".2-2") : (product.UnitPrice |
                        number: ".2-2"))) : ''
                    }}
                  </div>
                  <div class="search-row-stock" *ngIf="product.ExternalProductID !== ''">
                    {{
                    product.StockOnHand === null
                      ? 'N/A' : product.StockOnHand
                    }}
                  </div>
                </div>
              </ng-template>
            </p-autoComplete>
            <span class="fa hubtiger-search" *ngIf="canGetQuantities() === 'NO'"></span>
            <span class="fa hubtiger-inventory red" *ngIf="canGetQuantities() === 'NARROW SEARCH'"
                  pTooltip="{{ 'bikeshop.modal.update_job_card.quote.get_quantities_blocked' | translate }}"></span>
            <span class="fa hubtiger-inventory green" *ngIf="canGetQuantities() === 'YES'"
                  (click)="getSearchResultQuantities(true)"
                  pTooltip="{{ 'bikeshop.modal.update_job_card.quote.get_quantities_allowed' | translate }}"></span>
          </div>
          <div class="add-new" *ngIf="canManageProducts">
            <div pTooltip="{{ 'bikeshop.pos_products.add_product_quote' | translate }}"
                 tooltipPosition="left"
                 class="hubtiger-add pull-right" (click)="addProductOverlay.toggle($event)"></div>
            <div style="position: absolute;right: 546px;margin-top: -30px;">
              <p-overlayPanel #addProductOverlay [dismissable]="false" [showCloseIcon]="true"
                              (onShow)="productPanelVisible()" (onHide)="productPanelHidden()">
                <app-add-product-panel (update)="newProductAdded($event)"></app-add-product-panel>
              </p-overlayPanel>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="quote-table">
      <div class="row header">
        <div class="col-2">
          {{ "bikeshop.modal.update_job_card.quote.sku" | translate }}
        </div>
        <div class="col-3"
             *ngIf="partner.POSSystemID==3 || partner.POSSystemID==6 || partner.POSSystemID==9 || partner.POSSystemID==16 || partner.POSSystemID==10 ">
          {{ "bikeshop.modal.update_job_card.quote.name" | translate }}
        </div>
        <div class="col-4"
             *ngIf="partner.POSSystemID!=3 && partner.POSSystemID!=6 && partner.POSSystemID!=9  && partner.POSSystemID!=16 && partner.POSSystemID!=10 ">
          {{ "bikeshop.modal.update_job_card.quote.name" | translate }}
        </div>
        <div class="col-1"
             *ngIf="partner.POSSystemID==3 || partner.POSSystemID==6 || partner.POSSystemID==9 || partner.POSSystemID==16 || partner.POSSystemID==10">
          {{ "general.quantity_in_stock" | translate }}
        </div>
        <!--<div class="col-3">Description</div>-->
        <!--<div class="col-1">Brand</div>-->
        <div class="col-1 right" *ngIf="allowDiscount">
          <span>
            {{
            "bikeshop.modal.update_job_card.quote.discount_abbr" | translate
            }}
          </span>
        </div>
        <div class="col-1 right" *ngIf="!allowDiscount"></div>
        <div class="col-1 right">
          {{ "bikeshop.modal.update_job_card.quote.qty" | translate }}
        </div>
        <div class="col-2 right" *ngIf="!VATInclusive">
          {{ "bikeshop.modal.update_job_card.quote.unit_price" | translate }}
        </div>
        <div class="col-2 right" *ngIf="VATInclusive">
          <span>
            {{
            "bikeshop.modal.update_job_card.quote.price_incl_vat" | translate
            }}

          </span>

        </div>

        <div class="col-2 actions">

          <!-- <span class="fa fa-fw hubtiger-add" *ngIf="!editing" (click)="addLineItem()" title="{{
            'bikeshop.modal.update_job_card.quote.add_new_line_item_to_quote'
              | translate
          }}"></span> -->
          <span class="fa fa-spinner fa-pulse" *ngIf="updatingQuote || sendingToPOS"
                style="height: fit-content"></span>
          <span joyrideStep="quoteStepTwo" style="padding-top: 5px;"
                text="{{ 'bikeshop.tour.quote.step_one' | translate }}" (done)="tourDone()">
            <span pTooltip="{{
            'bikeshop.modal.update_job_card.quote.pos_sync_tooltip' | translate
          }}" tooltipPosition="bottom" class="fa hubtiger-sync" style="margin-left: auto;margin-right: 8px;"
                  [ngClass]="{ 'fa-spin': syncingPOS }" (click)="syncPOS()"></span>
          </span>
        </div>
      </div>
      <div *ngFor="let lineItem of invoice.LineItems; let i = index; trackBy: trackByFn">
        <div *ngIf="!lineItem.edit" class="row line-item" [ngClass]="{'missing-line': !lineItem.FoundInPOS}">
          <div class="col-2" style="display: flex;overflow: hidden;"
               [ngClass]="{'missing-line-delete': !lineItem.FoundInPOS}">
            <span *ngIf="selectItemsForSpecialOrder" style="margin-right: 4px; width: 20px">
              <p-checkbox [(ngModel)]="lineItem.SendToPOS" [binary]="true" [disabled]="sendingToPOS"
                          *ngIf="!lineItem.ExternalKey || lineItem.ExternalKey.length === 0 || (lineItem.Note === 'ORDER OFFERED' && lineItem.SpecialOrderStatus === null && !hasStock(lineItem))">
              </p-checkbox>
              <!-- <p-checkbox [(ngModel)]="lineItem.SendToPOS" binary="true" [disabled]="sendingToPOS" *ngIf="lineItem.Note === 'ORDER OFFERED' && lineItem.SpecialOrderStatus === null && !hasStock(lineItem)"></p-checkbox> -->
            </span>
            <span *ngIf="!selectItemsForSpecialOrder && invoice.ExternalKey != null" [ngClass]="{
              'hubtiger-pos-not-sent': (lineItem.ExternalKey === null || lineItem.ExternalKey === '') && invoice.ExternalKey != null,
              'hubtiger-pos-sent': (lineItem.ExternalKey !== null && lineItem.ExternalKey !== '') && invoice.ExternalKey != null
            }"></span>{{ lineItem.SKU }}
          </div>
          <div style="overflow: hidden" class="col-3"
               *ngIf="partner.POSSystemID==3 || partner.POSSystemID==6 || partner.POSSystemID==9  || partner.POSSystemID==16  || partner.POSSystemID==10 "
               [ngClass]="{'missing-line-delete': !lineItem.FoundInPOS}"
               pTooltip="{{lineItem.SKU === lineItem.Name ? lineItem.Description : lineItem.Name}}"
               tooltipPosition="bottom">
            {{
            lineItem.SKU === lineItem.Name
              ? lineItem.Description
              : lineItem.Name
            }}
            <div *ngIf="partner.ShowLineItemNotesOnJobcard !== undefined">
              <div *ngIf="partner.ShowLineItemNotesOnJobcard">
                <div *ngIf="lineItem.LineItemNote">
                  <div *ngIf="partner.ShowLineItemNotesOnJobcard && lineItem.LineItemNote.length > 0"
                       class="note">{{lineItem.LineItemNote}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-4" style="overflow: hidden"
               *ngIf="partner.POSSystemID!=3 && partner.POSSystemID!=6 && partner.POSSystemID!=9 && partner.POSSystemID!=16 && partner.POSSystemID!=10"
               [ngClass]="{'missing-line-delete': !lineItem.FoundInPOS}">
            {{
            lineItem.SKU === lineItem.Name
              ? lineItem.Description
              : lineItem.Name
            }}
            <div *ngIf="partner.ShowLineItemNotesOnJobcard !== undefined">
              <div *ngIf="partner.ShowLineItemNotesOnJobcard">
                <div *ngIf="lineItem.LineItemNote">
                  <div *ngIf="partner.ShowLineItemNotesOnJobcard && lineItem.LineItemNote.length > 0"
                       class="note">{{lineItem.LineItemNote}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-1"
               *ngIf="partner.POSSystemID==3 || partner.POSSystemID==6 || partner.POSSystemID==9 || partner.POSSystemID==16 || partner.POSSystemID==10 "
               [ngClass]="{'missing-line-delete': !lineItem.FoundInPOS}">

            {{lineItem.StockOnHand <= 0 ? '-' : lineItem.StockOnHand}}
          </div>

          <!--<div class="col-3">{{lineItem.Description}}</div>-->
          <!--<div class="col-1">{{lineItem.Brand}}</div>-->
          <div class="col-1 right" *ngIf="allowDiscount"
               [ngClass]="{'missing-line-delete': !lineItem.FoundInPOS}">
            {{ invoice.CurrencySymbol }}
            {{ (lineItem.Discount ? lineItem.Discount : 0) | number: ".2-2" }}
          </div>
          <div class="col-1 right" *ngIf="!allowDiscount"
               [ngClass]="{'missing-line-delete': !lineItem.FoundInPOS}">
          </div>
          <div class="col-1 right" [ngClass]="{'missing-line-delete': !lineItem.FoundInPOS}">
            <p-inplace #qty (click)="editLineItem(i)" *ngIf="!editing && invoice.StatusID !='10'  " [disabled]="!canEditLineItemQuantity(lineItem)">
              <span pInplaceDisplay>
                {{ lineItem.Quantity }}
              </span>
              <span pInplaceContent>
                <div class="p-inputgroup">
                  <input type="number" min="0" pInputText [(ngModel)]="editLine.Quantity" #qty
                         placeholder="{{
                    'bikeshop.modal.update_job_card.quote.qty' | translate
                  }}"/>
                </div>
              </span>
            </p-inplace>
            <p-inplace #qty *ngIf="!editing && invoice.StatusID =='10'">
              <span pInplaceDisplay>
                {{ lineItem.Quantity }}
              </span>
              <span pInplaceContent>
                {{ lineItem.Quantity }}
              </span>
            </p-inplace>
            <span *ngIf="editing">{{ lineItem.Quantity }}</span>
          </div>
          <div class="col-2 right" *ngIf="!VATInclusive"
               [ngClass]="{'missing-line-delete': !lineItem.FoundInPOS}">
            {{ invoice.CurrencySymbol }} {{ lineItem.UnitPrice | number: ".2-2" }}
          </div>
          <div class="col-2 right" *ngIf="VATInclusive"
               [ngClass]="{'missing-line-delete': !lineItem.FoundInPOS}">
            <span *ngIf="VATInclusive">
              {{ invoice.CurrencySymbol }}
              {{ lineItem.UnitPrice_IncludingTax | number: ".2-2" }}
            </span>
          </div>
          <div class="col-2 actions" *ngIf="invoice.StatusID !='10'">
                        <span *ngIf="!editing && !gettingInventory && lineItem.FoundInPOS === false"
                              class="hubtiger-pos-not-found" title="Product no longer in the POS."></span>
            <span
              *ngIf="!editing && !gettingInventory && lineItem.Note === 'ORDER OFFERED' && lineItem.SpecialOrderStatus === null && !hasStock(lineItem)"
              class="hubtiger-out-of-stock"></span>
            <span *ngIf="!editing && lineItem.SpecialOrderStatus && lineItem.SpecialOrderStatus.length>0"
                  [ngClass]="{ 'hubtiger-order-ready' : lineItem.SpecialOrderStatus.indexOf('Ready') > -1, 'hubtiger-order-not-ordered' : lineItem.SpecialOrderStatus === 'Not Ordered', 'hubtiger-order-ordered' : lineItem.SpecialOrderStatus === 'Ordered'}"></span>
            <span class="fa fa-fw hubtiger-edit" (click)="editLineItem(i)"
                  *ngIf="!selectItemsForSpecialOrder && !editing" title="Edit line item."></span>
            <span class="fa fa-fw hubtiger-delete" (click)="deleteLineItem(i)"
                  *ngIf="!selectItemsForSpecialOrder && !editing" title="{{
              'bikeshop.modal.update_job_card.quote.delete_line_item_from_quote'
                | translate
            }}"></span>
            <span class="fa fa-fw"
                  [ngClass]="{ 'hubtiger-sticky-note': lineItem.LineItemNote === undefined || lineItem.LineItemNote === null || lineItem.LineItemNote === '', 'hubtiger-sticky-note-text': lineItem.LineItemNote !== undefined && lineItem.LineItemNote !== null && lineItem.LineItemNote.length > 0 }"
                  *ngIf="!selectItemsForSpecialOrder && !editing"
                  pTooltip="{{lineItem.LineItemNote === undefined || lineItem.LineItemNote === null || lineItem.LineItemNote === '' ? ('bikeshop.modal.update_job_card.quote.add_line_item_note' | translate) : lineItem.LineItemNote}}"
                  tooltipPosition="bottom" (click)="lineItemNoteUpdate.toggle($event)"></span>
            <!-- <span class="fa fa-fw hubtiger-sticky-note" style="opacity: 0.25" *ngIf="!selectItemsForSpecialOrder && !editing && loading"></span> -->

            <span class="hubtiger-approved" *ngIf="!editing && lineItem.Approved === 1"
                  title="Approved line item."></span>
            <span class="hubtiger-not-approved" (click)="deleteLineItem(i)"
                  *ngIf="!editing && lineItem.Approved === 2" title="Not approved line item."></span>
            <span style="width:18px"
                  *ngIf="!editing && lineItem.Approved !== 2 && lineItem.Approved !== 1"></span>
            <div style="position: absolute;right: 430px;margin-top: 16px;">
              <p-overlayPanel #lineItemNoteUpdate [dismissable]="false" [showCloseIcon]="true"
                              (onShow)="productPanelVisible()" (onHide)="productPanelHidden()">
                <div style="width: 400px;">
                  <div class="overlay-title">
                    {{
                    'bikeshop.modal.update_job_card.quote.add_line_item_note' |
                      translate
                    }}
                  </div>
                  <div class="p-inputgroup">
                                        <textarea [rows]="5" pInputTextarea
                                                  [(ngModel)]="lineItem.LineItemNoteUpdate"></textarea>
                  </div>
                  <div style="display:flex;justify-content: flex-end;margin-top: 8px;">
                    <button pButton type="button" class="p-button-raised"
                            (click)="updateLineItemNote(lineItem, lineItemNoteUpdate)"
                            label="{{'bikeshop.modal.update_job_card.quote.update_note'| translate}}"></button>
                  </div>
                </div>
              </p-overlayPanel>
            </div>
          </div>
        </div>
        <div *ngIf="lineItem.edit" class="row line-item edit">
          <div class="col-2" style="overflow : visible">
            <p-autoComplete #lineItemProductSearchComponent [(ngModel)]="editLine" field="SKU"
                            [suggestions]="searchResult" placeholder="{{
              'bikeshop.modal.update_job_card.quote.enter_sku_or_name'
                | translate
            }}" (completeMethod)="searchProducts($event)" (onSelect)="skuSelected($event)">
              <ng-template let-product pTemplate="item">
                <div>
                  <span>
                    {{ product.SKU }} - {{ product.Name }} {{
                    product.UnitPrice ? (' - ' + partner.CurrencySymbol +
                      (partner.VATInclusive ? (product.UnitPrice_IncludingTax | number: ".2-2") : (product.UnitPrice |
                        number: ".2-2"))) : ''
                    }}
                  </span>
                </div>
              </ng-template>
            </p-autoComplete>
          </div>
          <div class="col-4" style="overflow: hidden">{{ editLine.Name }}</div>
          <!--<div class="col-1">{{editLine.Brand}}</div>-->
          <div class="col-1" *ngIf="allowDiscount" style="overflow:visible">
            <div *ngIf="discountType === 'AMOUNT'">
              <input type="number" pInputText [(ngModel)]="editLine.Discount"/>
            </div>
            <div class="p-inputgroup" *ngIf="discountType === 'PERCENTAGE'">
              <p-dropdown [options]="discounts" class="full-width"
                          [(ngModel)]="editLine.DiscountID"></p-dropdown>
            </div>
          </div>
          <div class="col-1 right" *ngIf="!allowDiscount"></div>
          <div class="col-1 right">

            <input type="number" min="0" pInputText [(ngModel)]="editLine.Quantity" #quantityComponent [disabled]="!canEditLineItemQuantity(lineItem)"
                   (keyup.enter)="updateLine(i)" placeholder="{{
              'bikeshop.modal.update_job_card.quote.qty' | translate
            }}"/>
          </div>
          <div class="col-2 right" style="overflow:visible">
            <!-- <span *ngIf="editLine.Price > 0">
              {{ invoice.CurrencySymbol }}
              {{
                  VATInclusive
                    ? editLine.UnitPrice_IncludingTax
                    : editLine.UnitPrice
              }}
            </span> -->
            <input *ngIf="VATInclusive" type="number" pInputText
                   [(ngModel)]="editLine.UnitPrice_IncludingTax"
                   placeholder="{{
                'bikeshop.modal.update_job_card.quote.unit_price' | translate
              }}" style="text-align: right; margin-right: -16px; padding-right: 25px;"/>
            <input *ngIf="!VATInclusive" type="number" pInputText [(ngModel)]="editLine.UnitPrice"
                   placeholder="{{
                'bikeshop.modal.update_job_card.quote.unit_price' | translate
              }}" style="text-align: right; margin-right: -16px; padding-right: 25px;"/>
          </div>
          <div class="col-2 actions">
            <span class="save" *ngIf="editLine.UnitPrice >= 0" (click)="updateLine(i)">
              {{
              "bikeshop.general.save" |
                translate
              }}
            </span>
          </div>
        </div>
      </div>


      <div class="view-in-pos-container" *ngIf="!selectItemsForSpecialOrder">
        <div>
          <button pButton type="button"
                  *ngIf="!useWorkOrdersForWorkshop && invoice.ExternalKey && invoice.ExternalKey !== '0'  && (POSName === 'Lightspeed R' || POSName === 'Xero' || POSName === 'Citrus Lime')"
                  class="p-button-raised full-width alternate" (click)="openPOSURL()"
                  label="{{'bikeshop.modal.update_job_card.quote.view_quote_in'| translate}} {{ POSName }}"></button>
          <button pButton type="button"
                  *ngIf="useWorkOrdersForWorkshop && invoice.WorkOrderID"
                  class="p-button-raised full-width alternate" (click)="openWorkOrderURL()"
                  label="{{'bikeshop.workshop.jobcard.view_work_order'| translate}}"></button>
          <button pButton type="button" style="cursor:default;"
                  *ngIf="invoice.ExternalKey && (POSName === 'Shopify')"
                  class="p-button-raised full-width alternate"
                  label="{{'bikeshop.modal.update_job_card.quote.view_quote_in'| translate}} {{ POSName }}: {{ invoice.ExternalRefNo }}"></button>
          <button pButton type="button" style="text-align: left;"
                  *ngIf="invoice.ExternalKey && (partner.POSSystemID === 16)"
                  class="p-button-raised full-width alternate" (click)="openPOSURL()"
                  label="{{'bikeshop.modal.update_job_card.quote.view_quote_in'| translate}} {{ POSName }}: {{ invoice.ExternalRefNo }}"></button>
                  
   <button pButton type="button" style="text-align: left;"
                  *ngIf="invoice.ExternalKey && (partner.POSSystemID === 19 && partner.POSCustomURL != null && partner.POSCustomURL.length > 0)"
                  class="p-button-raised full-width alternate" (click)="openPOSURL()"
                  label="{{'bikeshop.modal.update_job_card.quote.view_quote_in'| translate}} {{ POSName }}: {{ invoice.ExternalRefNo }}"></button>

          <button pButton type="button" style="text-align: left;"
                  *ngIf="invoice.SynchFeedback && invoice.SynchFeedback !== '' && (partner.POSSystemID === 16)"
                  class="p-button-raised full-width alternate" (click)="openPOSURL_SalesOrder()"
                  label="Sales order: {{ invoice.SynchFeedback.split('|')[1] }}"></button>
        </div>
        <div>
          <button pButton type="button" *ngIf="needSpecialOrder && POSName === 'Lightspeed R'"
                  class="p-button-raised full-width alternate red"
                  (click)="enableSpecialOrderItemSelection()"
                  label="{{'bikeshop.modal.update_job_card.select_special_order_items'| translate}}"></button>
        </div>
      </div>
      <div class="view-in-pos-container" *ngIf="selectItemsForSpecialOrder">
        <div>
          <button pButton type="button" class="p-button-raised full-width alternate"
                  (click)="selectItemsForSpecialOrder = false" label="{{'general.cancel'| translate}}"
                  [disabled]="sendingToPOS"></button>
        </div>
        <div style="margin-left: 32px">
          <button pButton type="button" class="p-button-raised full-width alternate red"
                  (click)="openSpecialOrderPOS()"
                  label="{{'bikeshop.modal.update_job_card.create_special_order'| translate}}"
                  [disabled]="!checkSpecialOrderItemsSelected() || sendingToPOS"></button>
        </div>
      </div>


      <div class="totals">
        <div class="row">
          <div class="col-6"></div>
          <div class="col-2 right">
            {{ "bikeshop.modal.update_job_card.quote.sub-total" | translate }}:
          </div>
          <div class="col-2 right">
            {{ invoice.CurrencySymbol }}
            {{ invoice.Total_LineItems | number: ".2-2" }}
          </div>
        </div>
        <div class="row" *ngIf="allowDiscount">
          <div class="col-6"></div>
          <div class="col-2 right">
            {{ "bikeshop.modal.update_job_card.quote.discount" | translate }}:
          </div>
          <div class="col-2 right">
            {{ invoice.CurrencySymbol }}
            {{ invoice.Total_Discounts | number: ".2-2" }}
          </div>
        </div>
        <div class="row" *ngIf="helpersService.showTaxRow(invoice.Total_Tax, partner)">
          <div class="col-6"></div>
          <div class="col-2 right">
            {{ "bikeshop.modal.update_job_card.quote.vat" | translate }}:
          </div>
          <div class="col-2 right">
            {{ invoice.CurrencySymbol }} {{ invoice.Total_Tax | number: ".2-2" }}
          </div>
        </div>
        <div class="row">
          <div class="col-6"></div>
          <div class="col-2 right">
            {{ "bikeshop.modal.update_job_card.quote.total" | translate }}:
          </div>
          <div class="col-2 right">
            {{ invoice.CurrencySymbol }}
            {{ invoice.Total_Price | number: ".2-2" }}
          </div>
        </div>
      </div>
      <div class="row margin-top-16">
        <div class="col-12">
          <div class="delayed-call" *ngIf="showTakingTooLong && sendingToPOS">
            <!-- <div class="delayed-call"> -->
            {{'bikeshop.modal.update_job_card.quote.send_to_pos_taking_too_long' | translate : {POSName: POSName} }}
          </div>
        </div>
      </div>
      <div class="row margin-top-16" style="align-items: end;"
           *ngIf="(tourBusy || (invoice && invoice.LineItems && invoice.LineItems.length > 0))">
        <div class="col-2" *ngIf="partner.POSSystemID !== 16"></div>
        <div class="col-4" *ngIf="invoice.StatusID !='10'">
          <div *ngIf="jobcard.ThirdPartyID != null" style="display: flex;align-items: center;">
            <p-inputSwitch [(ngModel)]="sendToThirdPartyOnly"></p-inputSwitch>
            <small style="margin-left: 16px;">{{ "bikeshop.modal.update_job_card.quote.send_to_third_party_only" | translate }}</small>
          </div>
          <div joyrideStep="quoteStepThree" text="{{ 'bikeshop.tour.quote.step_one' | translate }}"
               (done)="tourDone()">
            <button pButton type="button" class="p-button-raised full-width" (click)="sendForApproval()"
                    label="{{
            'bikeshop.modal.update_job_card.quote.button.send_for_approval'
              | translate
          }}" [disabled]="
            invoice.AskForApproval || updatingQuote || editing || sent || tourBusy || selectItemsForSpecialOrder || showProductPanel
          "></button>
          </div>
        </div>

        <div class="col-4" *ngIf="invoice.StatusID !='10' && partner.POSSystemID === 16">
          <div joyrideStep="quoteStepFour" text="{{ 'bikeshop.tour.quote.step_one' | translate }}"
               (done)="tourDone()">
            <button pButton type="button" class="p-button-raised full-width"
                    (click)="createSalesOrder(true, null)" label="Create Sales Order"
                    [disabled]="updatingQuote || editing || disablePOS || tourBusy || sendingToPOS || selectItemsForSpecialOrder || showProductPanel || partner.POSSystemID <= 0"></button>
          </div>
        </div>

        <div class="col-4" *ngIf="invoice.StatusID !='10' && !useWorkOrdersForWorkshop">
          <div joyrideStep="quoteStepFour" text="{{ 'bikeshop.tour.quote.step_one' | translate }}"
               (done)="tourDone()">
            <button pButton type="button" class="p-button-raised full-width"
                    (click)="sendToPOS(true, null)" label="{{
            'bikeshop.modal.update_job_card.quote.button.send_to_pos'
              | translate
          }} {{ POSName }}"
                    [disabled]="updatingQuote || editing || disablePOS || tourBusy || sendingToPOS || selectItemsForSpecialOrder || showProductPanel || partner.POSSystemID <= 0"></button>
          </div>
        </div>
        <div class="col-4" *ngIf="invoice.StatusID !='10' && useWorkOrdersForWorkshop">
          <div joyrideStep="quoteStepFour" text="{{ 'bikeshop.tour.quote.step_one' | translate }}"
               (done)="tourDone()">
            <button pButton type="button" class="p-button-raised full-width"
                    (click)="sendToPOS(true, null)" label="{{'bikeshop.workshop.jobcard.sync_work_order'| translate}}"
                    [disabled]="updatingQuote || editing || disablePOS || tourBusy || sendingToPOS || selectItemsForSpecialOrder || showProductPanel || partner.POSSystemID <= 0"></button>
          </div>
        </div>

      </div>
      <div *ngIf="jobcard.PaidWithStripe" class="paid-with-stripe">
        <span class="text">{{ "bikeshop.modal.update_job_card.job_card.customer_paid_with" | translate }}</span>
        <span class="icon fa fa-cc-stripe"></span>
      </div>
      <div *ngIf="jobcard.PaidWithPOS" class="paid-with-pos">
        <span class="text">{{ "bikeshop.modal.update_job_card.job_card.customer_paid_with_pos" | translate }}</span>
      </div>
    </div>
  </div>
</div>


<div *ngIf="!sendingToPOS && !showInvoiceOptions && invoice && invoice.ID">
  <app-service-payment-history [invoice]="invoice" [partner]="partner"></app-service-payment-history>
</div>

<div class="margin-top-16">
  <div class="row" *ngIf="
       isDev &&
       invoice &&
       invoice.LineItems &&
       invoice.LineItems.length>0 &&
    invoice.ExternalKey != null
    ">
    <div class="col-4"></div>
    <div class="col-6 right sync-message" style="display: flex;">
      <span class="hubtiger-pos-sent"></span>{{
      "bikeshop.modal.update_job_card.quote.item-sent-to-pos" | translate
      }}<span class="hubtiger-pos-not-sent" style="margin-left:8px;"></span>{{
      "bikeshop.modal.update_job_card.quote.item-not-sent-to-pos"
        | translate
      }}
    </div>
  </div>
</div>

<p-confirmDialog key="quote-order-confirmation" header="Confirmation" icon="pi pi-exclamation-triangle" [baseZIndex]="1"
                 [autoZIndex]="false"></p-confirmDialog>
